import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerServiceWorker } from '@coeldery/pwa-spa';
import { applyFontScale, getFontScale } from './lib/settings';
import './i18n';
import App from './App';
import './styles.css';

// PWA：**只喺生產 build 註冊**（dev 註冊會 cache 住舊 asset，令 HMR 鬼打牆）。
// SW 只快取外殼：HTML 同 `/api/*` 一律 network-only（每次入 app 拎最新數）。
registerServiceWorker({ enabled: import.meta.env.PROD });

// 套用使用者設定嘅字級（localStorage；`--font-scale`）
applyFontScale(getFontScale());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
